import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_JOB_PACK = restRequest("VRCORE.JOB_PACK_V2.GET_JOB_PACK");
export const GET_NEW_JOB_PACK_UID = restRequest(
    "VRCORE.JOB_PACK_V2.GET_NEW_JOB_PACK_UID"
);
export const GET_USERS = restRequest("VRCORE.JOB_PACK_V2.GET_USERS");
export const UPLOAD_FILE = restRequest("VRCORE.JOB_PACK_V2.UPLOAD_FILE");
export const SET_JOB_PACK = restRequest("VRCORE.JOB_PACK_V2.SET_JOB_PACK");
export const GET_REPORT_TYPES = restRequest(
    "VRCORE.JOB_PACK_V2.GET_REPORT_TYPES"
);
export const GET_SSWP_CONFIGS = restRequest(
    "VRCORE.JOB_PACK_V2.GET_SSWP_CONFIGS"
);
